<template>
    <div v-if="pageNews.length">
        <div class="page-blog">
            <v-container>
                <div class="page-blog__title">
                    <i class="icon-blog"></i>
                    <div class="text">
                        <h1>{{ $t('front.news.page.title') }}</h1>
                        <p>{{ $t('front.news.page.description') }}</p>
                    </div>
                </div>
                <div class="page-blog__list">
                    <div class="item" v-for="item in pageNews">
                        <div class="item__image">
                            <router-link :to="item.pageUrl">
                                <picture>
                                    <source
                                        :srcset="item[isDeviceMobile ? 'mobileImage' : 'desktopImage'][sourceType]"
                                        :type="`image/${sourceType}`"
                                        v-for="(sourceType, index) in item[isDeviceMobile ? 'mobileImage' : 'desktopImage'].sourcesTypes"
                                        :key="index">
                                    <img :src="item[isDeviceMobile ? 'mobileImage' : 'desktopImage'].jpg"
                                         :alt="item.title"/>
                                </picture>
                            </router-link>
                        </div>
                        <div class="item__content">
                            <div class="item__content-top">
                                <h2 v-text="item.title"/>
                                <router-link :to="item.categoryPageUrl">{{ item.categoryTitle }}</router-link>
                            </div>
                            <div class="item__content-desc" v-text="item.shortDescription"/>
                            <div class="item__content-bottom">
                                <router-link :to="item.pageUrl">{{ $t('front.news.button.read_more') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <query-string-paginator v-model="page" :length="totalPages" :links-count="8" @change="changePage"/>

            </v-container>
        </div>

    </div>
</template>

<script>
import apiData from "../../../../mixins/apiData";

export default {
    name: "NewsItems",

    mixins: [apiData],

    data: function () {
        return {
            page: this.$route.query.page && parseInt(this.$route.query.page) || 1,
        }
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();
    },

    watch: {
        '$route'(route, oldRoute) {
            if (route.path !== oldRoute.path){
                this.page = 1;
            }

            this.fetchData();
        }
    },

    metaInfo() {
        if (this.newsCategory) {
            return this.newsCategory.metaInfo;
        } else if (this.firstNewsTag) {
            return this.firstNewsTag.metaInfo;
        }else {
            return {};
        }
    },

    computed: {
        isDeviceMobile() {
            return this.$store.state.isDeviceMobile;
        },

        isWebpSupported() {
            return this.$store.state.isWebpSupported;
        },

        locale() {
            return this.$store.state.locale;
        },

        tagsSlugs() {
            let tags = this.$route.params.tag;
            return tags && tags.split(',') || [];
        },

        firstNewsTag() {
            return this.tagsSlugs.length && this.$store.state.newsTags.find(tag => this.tagsSlugs.includes(tag.slug))
        },

        categorySlug() {
            return this.$route.params.category || '';
        },

        newsCategory() {
            return this.categorySlug && this.$store.state.newsCategories.find(category => category.slug === this.categorySlug);
        },

        pageNews() {
            return this.$store.state.pageNews[this.page] || [];
        },

        totalPages() {
            return this.$store.state.newsPagesCount;
        },
    },

    methods: {
        fetchData() {
            return Promise.all([
                this.$store.dispatch('FETCH_NEWS_TAGS', this.createApiData()),
                this.$store.dispatch('FETCH_NEWS_CATEGORIES', this.createApiData()),
                this.$store.dispatch('FETCH_PAGE_NEWS', this.createApiData({
                    page: this.page,
                    tags: this.tagsSlugs,
                    category: this.categorySlug,
                })),
            ]);
        },

        changePage() {
            let query = Object.assign({}, this.$route.query);

            if (this.page > 1){
                query.page = this.page;
            }else {
                delete query.page
            }

            let linkRoute = this.$router.resolve({
                query: query,
            });

            this.$router.push(linkRoute.resolved.fullPath);
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/target/NewsItems"
</style>